import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useProviderPriceList, { useProviderPriceListForm } from '@hooks/useProviderPriceList'

import EntityActivity from '@components/EntityActivity'
import EntityAssets from '@components/EntityAssets'

import AdjustPricesByPercentage from '../AdjustPricesByPercentage'
import ProviderPriceListDetails from '../ProviderPriceListDetails'
import PriceListArchivedBanner from '../../../../components/PriceListArchivedBanner'
import ProviderPriceListTools from '../../../../components/ProviderPriceListTools'
import PageLayout from '../../../../components/PageLayout'

interface PageContentProps {
  providerPriceListId: number,
}

const PageContent = (props: PageContentProps) => {
  const { providerPriceListId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks,
    callbacks: {
      updateProviderPriceList,
    },
  } = pageContext

  const providerPriceListPayload = useProviderPriceList({ id: providerPriceListId })
  const {
    callbacks: {
      updateProviderPriceList: updateFn,
    },
    loading,
    providerPriceList,
    updating,
  } = providerPriceListPayload

  const providerPriceListFormPayload = useProviderPriceListForm(providerPriceList)
  const { entityState, saveEnabled } = providerPriceListFormPayload

  const updateProviderPriceListPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Price List Updated',
  }

  return (
    // @ts-expect-error TS2741
    <PageLayout providerPriceListPayload={providerPriceListPayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <PriceListArchivedBanner providerPriceListPayload={providerPriceListPayload} />

            <ProviderPriceListDetails
              providerPriceListFormPayload={providerPriceListFormPayload}
            />

            <AdjustPricesByPercentage providerPriceList={providerPriceList} />

            <EntityActivity subjectId={providerPriceListId} subjectType="ProviderPriceList" />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                loadingBubbleColor="white"
                marginLeft="auto"
                onClick={() => updateProviderPriceList(updateProviderPriceListPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <ProviderPriceListTools providerPriceListPayload={providerPriceListPayload} />

        <EntityAssets
          callbacks={callbacks}
          filters={{
            attachableId: providerPriceList?.id,
            attachableType: 'ProviderPriceList',
            attachmentType: 'provider_price_list_asset',
          }}
        />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
